import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    if (! document.startViewTransition) {
      return
    }

    this.boundRender = this._render.bind(this)
    addEventListener("turbo:before-frame-render", this.boundRender, { frame_id: this.element.id })
  }

  disconnect() {
    removeEventListener("turbo:before-frame-render", this.boundRender, { frame_id: this.element.id })
  }

  _render(event) {
    if (event.target !== this.element && this.element.tagName.toLowerCase() === "turbo-frame") {
      return
    }

    const originalRender = event.detail.render

    event.detail.render = (currentElement, newElement) => {
      document.startViewTransition(() => {
        originalRender(currentElement, newElement)
      })
    }
  }
}
